import React, { FC, Fragment } from "react";
import Image from "next/image";

import {
  Animation,
  CoreAnimationFieldsFragment,
  PixelMode,
} from "@/gql/generated/graphql";
import config from "@/lib/config";
import getAnimationThumbnail from "@/lib/getAnimationThumbnail";
type AnimationContentProps = {
  animation: CoreAnimationFieldsFragment;
};

const AnimationContent: FC<AnimationContentProps> = ({ animation }) => {
  const thumbFilename = getAnimationThumbnail({ animation });
  const staticVersion = animation.encoded ? animation.version : "default";
  const formats = animation.format?.split(",") ?? [];

  if (formats.includes("AVIF")) {
    return <Image
      style={{ imageRendering: "pixelated" }}
      src={`${config.s3Path}/${animation.url}/animation.avif?v=${staticVersion ?? 0
        }`}
      className="thread-animation"
      alt=""
      width={animation.width}
      height={animation.height}
      unoptimized
    ></Image>
  }

  return <video
    loop
    controls={false}
    playsInline
    muted
    autoPlay
    poster={thumbFilename}
    className="thread-animation"
  >
    <source
      src={`${config.s3Path}/${animation.url}/animation.mp4?v=${staticVersion ?? 0
        }`}
      type="video/mp4"
    />
  </video>
};

export default AnimationContent;
